import type { RouteObject } from "react-router-dom";
import { InventoryHomePage } from "./pages/InventoryHomePage";
import { MaterialListPage } from "./pages/MaterialListPage";
import { MaterialCreatePage } from "./pages/MaterialCreatePage";
import { MaterialRevisionCreatePage } from "./pages/MaterialRevisionCreatePage";
import { MaterialRevisionEditPage } from "./pages/MaterialRevisionEditPage";
import { MaterialDetailPage } from "./pages/MaterialDetailPage";
import { WarehouseListPage } from "./pages/WarehouseListPage";
import { StockPage } from "./pages/StockPage";
import { LotsPage } from "./pages/LotsPage";
import { UomListPage } from "./pages/UomListPage";
import { MaterialImportPage } from "./pages/MaterialImportPage";
import { StockReceiptImportPage } from "./pages/StockReceiptImportPage";
import { LabelSettingsPage } from "./pages/LabelSettingsPage";
import { PrintLabelPage } from "./pages/PrintLabelPage";
import { PrintBatchPage } from "./pages/PrintBatchPage";
import { PendingLotAllocationsPage } from "./pages/PendingLotAllocationsPage";
import { LotStatusCatalogsPage } from "./pages/LotStatusCatalogsPage";


import { InventoryHomeHelpPage } from "@/features/inventory/pages/help/InventoryHomeHelpPage";
import { MaterialListHelpPage } from "@/features/inventory/pages/help/MaterialListHelpPage";
import { WarehouseListHelpPage } from "@/features/inventory/pages/help/WarehouseListHelpPage";
import { StockHelpPage } from "@/features/inventory/pages/help/StockHelpPage";
import { LotsHelpPage } from "@/features/inventory/pages/help/LotsHelpPage";
import { MaterialImportHelpPage } from "@/features/inventory/pages/help/MaterialImportHelpPage";
import { StockReceiptImportHelpPage } from "@/features/inventory/pages/help/StockReceiptImportHelpPage";
import { LabelSettingsHelpPage } from "@/features/inventory/pages/help/LabelSettingsHelpPage";
import MaterialCreateHelp from "./help/material-create.mdx";
import MaterialDetailHelp from "./help/material-detail.mdx";
import MaterialRevisionCreateHelp from "./help/material-revision-create.mdx";
import MaterialRevisionEditHelp from "./help/material-revision-edit.mdx";
import UomListHelp from "./help/uom-list.mdx";
import PrintBatchHelp from "./help/print-batch.mdx";
import CatalogsHelp from "./help/catalogs.mdx";
import PendingAllocationsHelp from "./help/pending-allocations.mdx";

/**
 * ADR-072 Rule FMS-01/FMS-03
 * ADR-074: Inventory frontend routes
 */
export const inventoryRoutes: RouteObject[] = [
  { path: "help/inventory/inventory-home", element: <InventoryHomeHelpPage /> },
  { path: "help/inventory/material-list", element: <MaterialListHelpPage /> },
  { path: "help/inventory/warehouse-list", element: <WarehouseListHelpPage /> },
  { path: "help/inventory/stock", element: <StockHelpPage /> },
  { path: "help/inventory/lots", element: <LotsHelpPage /> },
  { path: "help/inventory/material-import", element: <MaterialImportHelpPage /> },
  { path: "help/inventory/stock-receipt-import", element: <StockReceiptImportHelpPage /> },
  { path: "help/inventory/label-settings", element: <LabelSettingsHelpPage /> },
  { path: "help/inventory/material-create", element: <MaterialCreateHelp /> },
  { path: "help/inventory/material-detail", element: <MaterialDetailHelp /> },
  { path: "help/inventory/material-revision-create", element: <MaterialRevisionCreateHelp /> },
  { path: "help/inventory/material-revision-edit", element: <MaterialRevisionEditHelp /> },
  { path: "help/inventory/uom-list", element: <UomListHelp /> },
  { path: "help/inventory/print-batch", element: <PrintBatchHelp /> },
  { path: "help/inventory/catalogs", element: <CatalogsHelp /> },
  { path: "help/inventory/pending-allocations", element: <PendingAllocationsHelp /> },
  {
    path: "inventory",
    element: <InventoryHomePage />,
  },
  {
    path: "inventory/materials",
    element: <MaterialListPage />,
  },
  {
    path: "inventory/materials/create",
    element: <MaterialCreatePage />,
  },
  {
    path: "inventory/materials/:familyId/revisions/create",
    element: <MaterialRevisionCreatePage />,
  },
  {
    path: "inventory/materials/:familyId/revisions/:id/edit",
    element: <MaterialRevisionEditPage />,
  },
  {
    path: "inventory/materials/:id",
	element: <MaterialDetailPage />,
  },
  {
    path: "inventory/materials/import",
    element: <MaterialImportPage />,
  },
  {
    path: "inventory/warehouses",
    element: <WarehouseListPage />,
  },
  {
    path: "inventory/stock",
    element: <StockPage />,
  },
  {
    path: "inventory/lots",
    element: <LotsPage />,
  },
  {
    path: "inventory/stock-receipts/import",
    element: <StockReceiptImportPage />,
  },
  {
    path: "inventory/uom",
    element: <UomListPage />,
  },
  {
    path: "inventory/label-settings",
    element: <LabelSettingsPage />,
  },
  {
    path: "inventory/lots/:lotId/print",
    element: <PrintLabelPage />,
  },
  {
    path: "inventory/print-batch",
    element: <PrintBatchPage />,
  },
  {
    path: "inventory/pending-allocations",
    element: <PendingLotAllocationsPage />,
  },
  {
    path: "inventory/catalogs",
    element: <LotStatusCatalogsPage />,
  },
];